import { UserService } from '@/services/user.service';

const initialState = () => ({
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  async deleteUser({ commit }, userId) {
    try {
      commit('SET_PENDING', true);
      await UserService.deleteUser(userId);
      commit('SET_RESOLVED');
    } catch (error) {
      commit('SET_ERROR', error.data);
      throw error;
    } finally {
      commit('SET_PENDING', false);
    }
  },
  async updateUserRole({ commit }, { id, role }) {
    try {
      commit('SET_PENDING', true);
      const user = await UserService.updateUserRole(id, role);
      commit('SET_RESOLVED');
      return user;
    } catch (error) {
      commit('SET_ERROR', error.data);
      throw error;
    } finally {
      commit('SET_PENDING', false);
    }
  },
  async setUserPermission({ commit }, { id, permissionId, granted }) {
    try {
      commit('SET_PENDING', true);
      const user = await UserService.setUserPermission(id, permissionId, granted);
      commit('SET_RESOLVED');
      return user;
    } catch (error) {
      commit('SET_ERROR', error.data);
      throw error;
    } finally {
      commit('SET_PENDING', false);
    }
  },
};

const mutations = {
  SET_PENDING(state, pending) {
    state.status.pending = pending;
  },
  SET_RESOLVED(state) {
    state.status.resolved = true;
    state.status.error = null;
  },
  SET_ERROR(state, error) {
    state.status.rejected = true;
    state.status.error = error;
  },
};

const getters = {
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const users = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
